// Real checkout URLs for each pack.
export const CHECKOUT_PRO =
  'https://profelisto.com.ar/checkouts/cn/hWNDzsNWWgQNw3WMElmY8Yio/es-ar?_r=AQABxKuDqQ9JcoVWi2hN0I8gkxtmUNVf4PZLn69hNZWheNs'

export const CHECKOUT_ELITE =
  'https://profelisto.com.ar/checkouts/cn/hWNDzsNhygvQhvERIKF8PhAI/es-ar?_r=AQAByXBkkHhS62u0UnfxYhQPNJqzn2K76WDAKHMLoxk-MYI'

// Generic CTAs across the page push the most-chosen option (Megapack Élite).
export const CHECKOUT_DEFAULT = CHECKOUT_ELITE
